<template>
  <div class="feedbacklist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="150px" :inline="true">
        <el-form-item :label="$t('manage.name86')" prop="tenantId" >
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%" clearable>
    <el-option
      v-for="item in tenantOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>
          <el-form-item :label="$t('operate.name131')" prop="submitterName">
            <el-input v-model="queryInfo.submitterName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name132')" prop="fdbkTitle">
            <el-input v-model="queryInfo.fdbkTitle" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name133')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
          </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name79')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name134')" prop="submitterName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name135')" prop="fdbkTitle" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name136')" prop="address" sortable></el-table-column>
      <el-table-column :label="$t('operate.name137')" prop="submitterEmail" sortable min-width="120"></el-table-column>
      <el-table-column :label="$t('operate.name138')" prop="submitTime" sortable></el-table-column>
      <el-table-column :label="$t('operate.name139')" prop="status" sortable>
        <template slot-scope="scope">
          <div>{{ ['',$t('screen.name50'),$t('screen.name51'),$t('screen.name52'),$t('screen.name53'),$t('screen.name54')][scope.row.status] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name9')" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('operate.name111') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-dialog :title="$t('screen.name55')" :visible.sync="detailsDialog" v-if="detailsDialog" :close-on-click-modal ="false" :before-close="handleClose" width="800px">
      <el-row class="row-style1">
        <el-col :span="8" class="col-style margin10">
          {{ $t('operate.name134') }}
        </el-col>
        <el-col :span="4" class="col-style margin10">
          {{ $t('operate.name135') }}
        </el-col>
        <el-col :span="12" class="margin10">
          {{ $t('operate.name136') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="8" class="col-style margin10">
          {{ feedbackDetail.submitterName }}
        </el-col>
        <el-col :span="4" class="col-style margin10">
          {{ feedbackDetail.fdbkTitle }}
        </el-col>
        <el-col :span="12" class="margin10">
          {{ feedbackDetail.address }}
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="8" class="col-style margin10">
          {{ $t('operate.name138') }}
        </el-col>
        <el-col :span="16" class="col-style margin10">
          {{ $t('operate.name139') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="8" class="col-style margin10">
          {{ feedbackDetail.submitTime }}
        </el-col>
        <el-col :span="16" class="col-style margin10">
          <el-select v-model="feedbackDetail.status" :placeholder="$t('public.name1')" @change="changeStatus">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="24" class="col-style margin10">
          {{ $t('operate.name176') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="24" class="col-style margin10">
          {{ feedbackDetail.fdbkContent }}
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="24" class="margin10">
         {{ $t('operate.name177') }}
        </el-col>
      </el-row>
      <el-row class="row-style3" v-if="feedbackDetail.feedbackAttchList.length > 0">
        <el-col :span="24" class="margin10"   style="display: flex;flex-direction: row;">
          <div  v-for="(item,index) in feedbackDetail.feedbackAttchList" :key="index" class="img-style">
            <el-image style="width: 100px; height: 100px" :src="item.attchName" :preview-src-list="srcList"></el-image>
            </div>
        </el-col>
      </el-row>
      <el-row class="row-style4"  v-else>
        <el-col :span="24" class="margin10">
          <div> {{ $t('bike.name81') }}</div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { findFeedbackPage, findFeedbackDetail, modifyFeedbackStatus } from '@/api/operate.js'
import { tenantList } from '@/api/manage.js'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      tenantOptions: [],
      queryInfo: {
        submitterName: '',
        fdbkTitle: '',
        status: '',
        pageSize: 10,
        pageNumber: 1,
        tenantId: ''
      },
      feedbackDetail: {},
      detailsDialog: false,
      srcList: [],
      statusList: [
        {
          value: 1,
          label: this.$t('screen.name50')
        },
        {
          value: 2,
          label: this.$t('screen.name51')
        },
        {
          value: 3,
          label: this.$t('screen.name52')
        },
        {
          value: 4,
          label: this.$t('screen.name53')
        },
        {
          value: 5,
          label: this.$t('screen.name54')
        }
      ],
      tableLoading: false,
      tableList: [],
      statusOption: [
        {
          value: '',
          label: this.$t('operate.name98')
        },
        {
          value: 1,
          label: this.$t('screen.name50')
        },
        {
          value: 2,
          label: this.$t('screen.name51')
        },
        {
          value: 3,
          label: this.$t('screen.name52')
        },
        {
          value: 4,
          label: this.$t('screen.name53')
        },
        {
          value: 5,
          label: this.$t('screen.name54')
        }
      ],
      total: 0,
      fdbkId: ''
    }
  },
  created() {
    console.log('userinfo===', this.userinfo)
  },
  mounted() {
    this.getDataList()
    this.loadOptions()
  },
  methods: {
    loadOptions() {
      const data = { page: 1, limit: 500, tenantType: 2 }
      tenantList(data).then(res => {
        if (res.data.list) {
          this.tenantOptions = res.data.list.map(item => ({
            value: item.tenantId,
            label: item.tenantName
          }))
        } else {
          this.tenantOptions = []
        }
      }).catch(() => {})
    },
    showDetailsDialog(row) {
      this.detailsDialog = true
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.fdbkId = row.fdbkId
      findFeedbackDetail({ fdbkId: row.fdbkId })
        .then(res => {
          loading.close()
          this.feedbackDetail = res.data.feedbackDetail
          this.feedbackDetail.feedbackAttchList.map((item) => {
            this.srcList.push(item.attchName)
          })
        })
        .catch(() => {
        })
    },
    getDataList() {
      this.tableLoading = true
      findFeedbackPage(this.queryInfo)
        .then(res => {
          this.tableList = res.data.feedbackPage.records
          this.total = res.data.feedbackPage.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },
    resetQuery() {
      this.queryInfo = {
        submitterName: '',
        fdbkTitle: '',
        status: '',
        pageSize: 10,
        pageNumber: 1
      }
      this.getDataList()
    },
    changeStatus(e) {
      modifyFeedbackStatus({ fdbkId: this.fdbkId, status: e })
        .then(res => {
          this.getDataList()
        })
        .catch(() => {
        })
    },
    handleClose() {
      this.detailsDialog = false
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getDataList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getDataList()
    }
  }
}
</script>
<style lang="scss" scoped>
.feedbacklist-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  .row-style1 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #f5f5f5;
  }
  .row-style2 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style3 {
    border: 1px solid #dcdddd;
    height: 120px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style4 {
    border: 1px solid #dcdddd;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .img-style{
    display: flex;
    flex-direction: row;
    width: 110px;
  }
  .col-style {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
